<template>
    <el-form-item :class="{getClassByCopy,'hidden':component.properties.sortType==='hidden','to-top':component.properties.sortType==='toTop','to-left':component.properties.sortType==='toLeft'}" class="label-run" :prop="component.archive.columnId" label-width="none" :label="component.properties.sortType==='hidden' ? '' : component.name">
    <el-tooltip class="component-explain-tooltip" v-if="component.properties.componentExplain" :content="component.properties.componentExplain" placement="bottom-start">
      <span class="fa fa-question-circle"></span>
    </el-tooltip>
      <div v-if="component.properties.labelContent" class="editor" :style="{'height':height}" @click="click" ref="editor"></div>
    </el-form-item>
</template>

<script>
import Editor from 'wangeditor'
import {componentMixin, calculationMixin} from './mixins'
import { heightMixin } from '@/components/shared/designAndRuntimeMixins/mixins.js'

export default {
  name: 'rc-label',
  mixins: [componentMixin, calculationMixin, heightMixin],
  props: ['component', 'value', 'index'],
  data () {
    return {
      content: '',
      isInitEditor: false
    }
  },
  created () {
    // 历史节点的 label 的值也需要计算
    if (this.component.properties.calculate && this.component.properties.calculate.enable) {
      this.initCal()
    }
    if (!this.component.properties.sortType) {
      this.component.properties.sortType = 'toLeft'
    }
  },
  methods: {
    initCal () {
      // 在当前的控件里面重写计算的初始化方法, 将计算的结果赋给当前标签
      let expression = this.component.properties.calculate.calculationPanelData.expression
      this.getCalculationValue({'path': this.getCurrentPath(),
        'expression': expression,
        'callback': (data) => {
          this.content = data
        }})
    },
    click () {
      this.eventBus.$emit('label.click', {component: this.component})
    },
    initEditor () {
      this.editor = new Editor(this.$refs.editor)
      this.editor.customConfig.zIndex = 100
      this.editor.customConfig.showLinkImg = false
      this.editor.create()
      this.editor.$textElem.attr('contenteditable', false)
      this.editor.txt.html(this.component.properties.labelContent)
      this.isInitEditor = true
      return Promise.resolve()
    }
  },
  mounted () {
    if (this.component.properties.labelContent) {
      this.initEditor()
    }
  },
  computed: {
    getLabelContent () {
      return this.content === '' ? this.component.properties.labelContent : `<div>${this.content}</div>`
    }
  },
  watch: {
    // 默认使用labelContent的值
    component: {
      handler (val) {
        this.editor.txt.html(val.properties.labelContent)
      },
      deep: true
    },
    // 如果需要执行计算，则吧计算的值覆盖原有的
    content (val) {
      // 如果没有初始化，则需要重新初始化富文本框
      if (!this.isInitEditor) {
        this.initEditor().then(res => this.editor.txt.html(val))
      }
    }
  }
}
</script>
<style lang="scss">
.layout-form .list-component-item .el-form-item.label-run.to-left  {
  height: 100%;
  .component-explain-tooltip {
    position: absolute;
    left: 70px;
    top: 8px;
  }
  .el-form-item__content {
    height: calc(100% - 28px);
    padding-left: 2px;
  }
  .label-run-content {
    height: 100%;
    overflow: auto;
  }
  .editor {
    overflow: auto;
    .w-e-toolbar {
      // 隐藏 富文本的标题
      display: none !important;
      border: none !important;
    }
    .w-e-text-container {
      border: none !important;
      -webkit-border-radius: 4px;
      -moz-border-radius: 4px;
      border-radius: 4px;
      // 修改 style属性的值
      height: auto!important;
      min-height: 28px!important;
    }
    .w-e-text {
      position: relative;
      padding-top: 4px;
      //top: -6px;
      p {
        margin: 0;
        padding: 0;
      }
    }
  }
}
.layout-form .list-component-item .el-form-item.label-run.hidden  {
  height: 100%;
  .component-explain-tooltip {
    position: absolute;
    left: -6px;
    top: 8px;
  }
  .el-form-item__content {
    height: calc(100% - 28px);
    padding-left: 2px;
  }
  .label-run-content {
    height: 100%;
    overflow: auto;
  }
  .editor {
    overflow: auto;
    .w-e-toolbar {
      // 隐藏 富文本的标题
      display: none !important;
      border: none !important;
    }
    .w-e-text-container {
      border: none !important;
      -webkit-border-radius: 4px;
      -moz-border-radius: 4px;
      border-radius: 4px;
      // 修改 style属性的值
      height: auto!important;
      min-height: 28px!important;
    }
    .w-e-text {
      position: relative;
      //top: -6px;
    }
  }
}
.layout-form .list-component-item .el-form-item.label-run.to-top {
  height: 100%;
  .el-form-item__label{
    margin-left: 0px !important;
  }
  .component-explain-tooltip {
    position: absolute;
    left: 70px;
    top: -20px;
  }
  .el-form-item__content {
    height: calc(100% - 28px);
    padding-left: 2px;
  }
  .label-run-content {
    height: 100%;
    overflow: auto;
  }
  .editor {
    overflow: auto;
    .w-e-toolbar {
      // 隐藏 富文本的标题
      display: none !important;
      border: none !important;
    }
    .w-e-text-container {
      border: none !important;
      -webkit-border-radius: 4px;
      -moz-border-radius: 4px;
      border-radius: 4px;
      // 修改 style属性的值
      height: auto!important;
      min-height: 28px!important;
    }
    .w-e-text {
      padding-top: 4px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-label.vue